// extracted by mini-css-extract-plugin
export var addButton = "_fs-0";
export var border = "_fs-8";
export var check = "_fs-h";
export var danger = "_fs-6";
export var dropdownContainer = "_fs-1";
export var editModalBody = "_fs-j";
export var footerContainer = "_fs-i";
export var fullWidth = "_fs-a";
export var hide = "_fs-9";
export var icon = "_fs-3";
export var input = "_fs-7";
export var inputFlex = "_fs-b";
export var inputWrapper = "_fs-c";
export var manualFocus = "_fs-5";
export var optionButton = "_fs-4";
export var pillWrapper = "_fs-e";
export var pointer = "_fs-2";
export var showOverflow = "_fs-f";
export var tagsFlex = "_fs-d";
export var xButton = "_fs-g";